








import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Team from '../../../../shared/components/Team.vue'
import leaguesService from '../../services/LeaguesService';
import ContestLineUp from "@/shared/components/LineUp.vue";

@Component({
    components: {
        Team,
        ContestLineUp
    },
})
export default class LeagueTeam extends Vue {
    @Prop() league !: number;
    private leagueProfile = {};
    private participants = [];

    @Watch('league')
    async onLeagueChanged(league: number) {
        this.leagueProfile = await leaguesService.fetchLeagueProfileInfo(league);
        await this.fetchParticipants();
    }

    async fetchParticipants() {
        this.participants = await leaguesService.fetchLeagueParticipants(this.league);
    }

}
